import { split, mergeWith, set, reduce, includes, isArray } from 'lodash';
import { isDev } from 'app/app-utils';

const defaultConfig = {
  API_BASE_URL: 'http://localhost:3001',
  AUTH: {
    msal: {
      auth: {
        clientId: '28acaba4-b8bd-4dcf-9a97-3d615ce57629',
        authority: 'https://login.microsoftonline.com/42bcfde0-1d85-4335-8bb2-ce31eac9b89d',
        redirectUri: 'https://localhost:3000',
        postLogoutRedirectUri: 'https://localhost:3000',
      },
      cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
      },
    },
    loginRequest: {
      scopes: split('openid,profile,email', ','),
    },
  },
};

// environment variable names to config value paths
const CfgPathMapping = {
  API_BASE_URL: 'API_BASE_URL',
  MSAL_AUTH_CLIENTID: 'AUTH.msal.auth.clientId',
  MSAL_AUTH_REDIRECTURI: 'AUTH.msal.auth.redirectUri',
  MSAL_AUTH_POSTLOGOUTREDIRECTURI: 'AUTH.msal.auth.postLogoutRedirectUri',
  MSAL_AUTH_AUTHORITY: 'AUTH.msal.auth.authority',
  MSAL_AUTH_KNOWNAUTHORITIES: 'AUTH.msal.auth.knownAuthorities',
  MSAL_AUTH_LOGINSCOPES: 'AUTH.loginRequest.scopes',
  APP_ENVIRONMENT: 'APP_ENVIRONMENT',
};

const runtimeConfig = reduce(
  window?.LubaUiAppConfig || {},
  (acc, value, key) => {
    // A key with no entry in CfgPathMapping (e.g. a stale/renamed env var, or a typo in
    // window.LubaUiAppConfig) has no mapped path - `set(acc, undefined, value)` would otherwise
    // silently write to a bogus `undefined` path instead of being skipped.
    if (!includes(Object.keys(CfgPathMapping), key)) {
      return acc;
    }
    if (includes(['MSAL_AUTH_LOGINSCOPES', 'MSAL_AUTH_KNOWNAUTHORITIES'], key)) {
      set(acc, CfgPathMapping[key], split(value, ','));
    } else {
      set(acc, CfgPathMapping[key], value);
    }
    return acc;
  },
  {}
);

// A plain `merge` combines arrays index-by-index, so a shorter runtime override (e.g. two scopes
// replacing the default three) would leave leftover default entries in the merged array instead of
// replacing it outright. `mergeWith` + this customizer makes a runtime array win completely.
const config = mergeWith({}, defaultConfig, runtimeConfig, (objValue, srcValue) => {
  if (isArray(srcValue)) {
    return srcValue;
  }
});

if (isDev()) {
  // process.env isn't dumped here: CRA only inlines a handful of build-time REACT_APP_*/NODE_ENV
  // values into the bundle in the first place, none of which add anything beyond what's already
  // logged below - and it now runs on TEST (see isDev's own doc comment), not just local dev.
  console.log('CONFIG', config);
  console.log('DEFAULT_CONFIG', defaultConfig);
  console.log('LubaUiAppConfig', window.LubaUiAppConfig);
  console.log('runtimeConfig', runtimeConfig);
}

export default config;
